export type RowBox = { top: number; bottom: number };

/**
 * Pixels to move the pane bottom up so no row starts inside the pane and
 * ends past it. 1px of slack matches the live measure. Hiding the only
 * row that starts inside the pane would blank the card, so that case
 * returns 0.
 */
export function overviewRowClipShrink(
  paneBottom: number,
  rows: RowBox[],
  rowHeight: number
): number {
  if (rowHeight <= 1) return 0;
  const startingInside = rows.filter((row) => row.top < paneBottom - 1);
  if (startingInside.length < 2) return 0;
  let shrink = 0;
  for (const row of startingInside) {
    if (row.bottom <= paneBottom + 1) continue;
    const need = paneBottom - row.top;
    if (need > 1 && need < rowHeight) shrink = Math.max(shrink, need);
  }
  return shrink;
}
